import { TMessageSchema, TOutcomingStatus, TMessagesMap, IParsedMessage } from '../../types/messages';
import { parseMessage } from './parseMessage';
import { updateExistingMessage } from './updateExistingMessage';

interface IProcessRawMessageParams {
  rawMessage: TMessageSchema;
  messagesMap: TMessagesMap;
  currentChatMessages: IParsedMessage[];
  userId: number;
  status?: TOutcomingStatus;
  checkRowVersion?: boolean;
}

/**
 * Обрабатывает сообщение с бэкенда: обновляет существующее или добавляет новое.
 * Возвращает обновленный массив сообщений
 */
export function processRawMessage({
  rawMessage,
  messagesMap,
  currentChatMessages,
  userId,
  status,
  checkRowVersion,
}: IProcessRawMessageParams): IParsedMessage[] {
  const messageItem = messagesMap.get(rawMessage.messageId);

  // Сценарий 1: Сообщение уже существует (обновление)
  if (messageItem) {
    const nextChatMessages = [...currentChatMessages];
    const { message, messageIndex } = messageItem;

    // обновляем только если обновился rowVersion
    if (!!checkRowVersion && message.message.rowVersion === rawMessage.rowVersion) {
      return nextChatMessages;
    }

    const parsedMessage = updateExistingMessage({
      messageItem,
      rawMessage,
      messagesMap,
    });

    if (nextChatMessages[messageIndex]) {
      nextChatMessages[messageIndex] = parsedMessage;
    }

    return nextChatMessages;
  }

  // Сценарий 2: Новое сообщение (добавление).
  // В карту не пишем: индексы выставит updateMessageIndexInMap в вызывающем коде,
  // когда длина массива изменилась
  const parsedMessage = parseMessage({ rawMessage, userId, status });

  return [...currentChatMessages, parsedMessage];
}
